import { render, staticRenderFns } from "./zxresult.vue?vue&type=template&id=8b77c268&scoped=true&"
import script from "./zxresult.vue?vue&type=script&lang=js&"
export * from "./zxresult.vue?vue&type=script&lang=js&"
import style0 from "./zxresult.vue?vue&type=style&index=0&id=8b77c268&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b77c268",
  null
  
)

export default component.exports